import { render, staticRenderFns } from "./ReportDadosTitular.vue?vue&type=template&id=63558b5f"
import script from "./ReportDadosTitular.vue?vue&type=script&lang=js"
export * from "./ReportDadosTitular.vue?vue&type=script&lang=js"
import style0 from "./ReportDadosTitular.vue?vue&type=style&index=0&id=63558b5f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VContainer,
  VIcon,
  VLayout,
})
